const firebaseConfig = {
  apiKey: "AIzaSyDuXDd_sNK3IVWpoWo7cvNGQHZeZO36JSs",
  authDomain: "assessment-9cd93.firebaseapp.com",
  projectId: "assessment-9cd93",
  storageBucket: "assessment-9cd93.appspot.com",
  messagingSenderId: "746327924583",
  appId: "1:746327924583:web:f7defc2d9d6c342ae199c2",
};

export default firebaseConfig;
